import axios from "../../utils/axios";

export const getEmployeesHome = async (params) => {
  const res = await axios.get("employee/getListPublic", {
    params,
  });

  return res;
};

export const getEmployees = async (params) => {
  const res = await axios.get("employee/getList", {
    params,
  });

  return res;
};

export const updatePhoto = async (employeeId, formData) => {
  const res = await axios.post(
    `employee/updateThumbnail/${employeeId}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return res;
};
